export default "__VITE_ASSET__khw7wF3H__"